import React from 'react';
import { createComponent } from '@lit/react';
import { IxSelectOption as IxSelectOptionLit } from '../selectoption/IxSelectOption.js';

customElements.define('ix-select', IxSelectOptionLit);

export const IxSelectOption = createComponent({
  tagName: 'ix-select-react',
  elementClass: IxSelectOptionLit,
  react: React,
  events: {
    onclick: 'onClick',
  },
});
